module.exports = __webpack_public_path__ + "media/images/emblems/Twann-Tuescherz-coat_of_arms-1f565572bebb858824fe70e6ef72b4dc.svg";